
import React from 'react';
import { ActionCardProps } from '@/types/action-card';
import { ActionCardBase } from './ActionCardBase';
import { cn } from '@/lib/utils';

export const WorkflowActionCard = (props: ActionCardProps) => {
  // Add workflow-specific styling or behavior here
  return (
    <ActionCardBase 
      {...props} 
      className={cn(
        "border-l-4 border-l-blue-400/40",
        props.className
      )}
    />
  );
};
